import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function SpiljaIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="SpiljaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M81,39.3c-1.7-4-4.1-7.6-7.2-10.7s-6.7-5.5-10.7-7.2c-4.2-1.8-8.6-2.6-13.1-2.6s-8.9,0.9-13.1,2.6
	c-4,1.7-7.6,4.1-10.7,7.2s-5.5,6.7-7.2,10.7c-1.8,4.2-2.6,8.6-2.6,13.1v6.2h67.3v-6.2C83.6,47.9,82.7,43.5,81,39.3z"/>
      <g id="Layer_2_1_">
        <g>
          <path fill="#3CAA78" d="M50,43.5c-4.9,0-9,4-9,9c0,0.9,0.3,1.6,0.5,2.4h17c0.2-0.8,0.5-1.6,0.5-2.4C59,47.5,55,43.5,50,43.5z" />
          <path fill="#3CAA78" d="M50,22.6c-16.5,0-29.8,13.3-29.8,29.8v2.4h14.2V50h-9.1c0.5-5.1,2.5-9.6,5.5-13.4l6.4,6.4l3.4-3.4
			l-6.4-6.4c3.7-3.1,8.3-5,13.4-5.5v9.1h4.8v-9.1c5.1,0.5,9.6,2.5,13.4,5.5l-6.4,6.4l3.4,3.4l6.4-6.4c3.1,3.7,5,8.3,5.5,13.4h-9.1
			v4.8h14.2v-2.4C79.8,36,66.5,22.6,50,22.6z"/>
        </g>
      </g>
    </svg>
  </SvgIcon>
}

export default SpiljaIcon;
